/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Landing_Telegram_Mock_Btn_LabelInputs */

const tr_landing_telegram_mock_btn_label = /** @type {(inputs: Landing_Telegram_Mock_Btn_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Etiket`)
};

const en_landing_telegram_mock_btn_label = /** @type {(inputs: Landing_Telegram_Mock_Btn_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Label`)
};

const de_landing_telegram_mock_btn_label = /** @type {(inputs: Landing_Telegram_Mock_Btn_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Etikett`)
};

const ru_landing_telegram_mock_btn_label = /** @type {(inputs: Landing_Telegram_Mock_Btn_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Этикетка`)
};

/**
* | output |
* | --- |
* | "Label" |
*
* @param {Landing_Telegram_Mock_Btn_LabelInputs} inputs
* @param {{ locale?: "tr" | "en" | "de" | "ru" }} options
* @returns {LocalizedString}
*/
export const landing_telegram_mock_btn_label = /** @type {((inputs?: Landing_Telegram_Mock_Btn_LabelInputs, options?: { locale?: "tr" | "en" | "de" | "ru" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Landing_Telegram_Mock_Btn_LabelInputs, { locale?: "tr" | "en" | "de" | "ru" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_landing_telegram_mock_btn_label(inputs)
	if (locale === "de") return de_landing_telegram_mock_btn_label(inputs)
	if (locale === "ru") return ru_landing_telegram_mock_btn_label(inputs)
	return tr_landing_telegram_mock_btn_label(inputs)
});